import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { api, state, ui } from '../../../../../../interfaces/interfaces';
import { Badge, Button, Grid2 as Grid, Paper } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import Version from '../../../../../../utilities/version';
import { CallMeBacksData } from './interface';
import { useAppSelector } from "@store/hooks";

const name = "EnquiryTabs";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index ? <div style={{ marginLeft: "10px" }}>{children}</div> : null}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const tabs = [{ label: 'Details' }, { label: 'Notes' }];

export const fetchAgain = async () => {
    // const date = new Date();
    // // date.setDate(date.getDate() - 1);
    // // set date month to march
    // date.setMonth(2);
    // // set date day to 15
    // date.setDate(15);
    // // set hour to 6 am
    // date.setHours(6);
    await api.fetchGetCallMeBackQueue({})
    await loadCallMeBack(ui.CallMeBacksModalData.leadId)
}

const loadCallMeBack = async (leadId: number) => {
    const data = await api.fetchGetCallMeBack(leadId)
    const dataNotes = await api.fetchGetCallMeBackNotes(leadId)
    // merge objects
    const mergedData = { ...data?.[0], notes: dataNotes };
    if (mergedData) {
        generateFormData(mergedData);
    }
}

const generateFormData = (data: any) => {
    // if data is array, then get first element
    data = data instanceof Array ? data[0] : data;

    const { title, leadId, forename, surname, contactNumber, email, accountCode, description, followUpNotes, sentSMS, sentEmail, callAttempts, dateTimeLastCalled, dateTimeSMSSent, dateTimeEmailSent, removed, isLocked, userId, username, dateTimeEnquiry, dateTimeFollowUp, dateTimeUpdated, notes } = data;

    const formData = { title, leadId, forename, surname, contactNumber, email, accountCode, description, followUpNotes, sentSMS, sentEmail, callAttempts, dateTimeLastCalled, dateTimeSMSSent, dateTimeEmailSent, removed, isLocked, userId, username, dateTimeEnquiry, dateTimeFollowUp, dateTimeUpdated, notes };

    ui.CallMeBacksModalData = formData;
}


const sendSMS = async (leadId: number) => {
    await api.fetchCallMeBackSendSMS({
        leadId,
        userId: state.UserId,
        source: Version.appName()
    })
    // mark sms sent
    ui.CallMeBacksModalData = { ...ui.CallMeBacksModalData, sentSMS: true, dateTimeSMSSent: new Date() }
    await fetchAgain();
}


const sendEmail = async (leadId: number) => {
    await api.fetchCallMeBackSendEmail({ leadId, userId: state.UserId, source: Version.appName() })
    // mark email sent
    ui.CallMeBacksModalData = { ...ui.CallMeBacksModalData, sentEmail: true, dateTimeEmailSent: new Date() }
    await fetchAgain();
}

interface Props {
    parent: string;
}

const EnquiryTabs: React.FC<Props> = ({ parent
}) => {
    const [value, setValue] = React.useState(0);
    const data = useAppSelector(({ ui }) => ui.CallMeBacksModalData) as CallMeBacksData;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        (<Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    {tabs.map((tab, index) => (
                        <Tab key={index} label={tab.label} {...a11yProps(index)} />
                    ))}
                </Tabs>
            </Box>
            {tabs.map((tab, index) => (
                <TabPanel key={index} value={index} index={index} >
                    {value === 0 && index === 0 && (<>
                        <Paper elevation={4} sx={{ p: .5, mt: 1 }}>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Customer name:</Typography></Grid>
                                    <Grid size={10}><Typography variant="body1">{data.forename} {data.surname}</Typography></Grid></Grid>
                            </Paper>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Enquiry date:</Typography></Grid>
                                    <Grid size={10}><Typography variant="body1">{new Date(data.dateTimeEnquiry).toLocaleString("en-GB")}</Typography></Grid></Grid>
                            </Paper>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Contact number:</Typography></Grid>
                                    <Grid size={10}>
                                        <Grid container justifyContent="space-between" alignItems="center">
                                            <Grid size={!data.sentSMS ? 10 : 8}><Typography variant="body1">{data.contactNumber}</Typography></Grid>
                                            {!data.sentSMS
                                                ? <Grid size={2}> <Button variant="contained" size='small' onClick={() => sendSMS(data.leadId)} fullWidth>Send SMS</Button> </Grid>
                                                : <Grid size={4}><Typography textAlign="right" variant="body1">{data.dateTimeLastCalled ? ("SMS sent - " + new Date(data.dateTimeLastCalled).toLocaleString("en-GB")) : ""}</Typography></Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Call attempts:</Typography></Grid>
                                    <Grid size={10}>
                                        <Grid container justifyContent="space-between" alignItems="center">
                                            <Grid size={5}><Badge sx={{ mb: -1 }} color="secondary" badgeContent={data.callAttempts} showZero><PhoneIcon /></Badge></Grid>
                                            <Grid size={4}><Typography textAlign="right" variant="body1">{data.dateTimeLastCalled ? ("Last call - " + new Date(data.dateTimeLastCalled).toLocaleString("en-GB")) : ""}</Typography></Grid>
                                            <Grid size={2}> <Button variant="contained" size='small' onClick={() => alert("Not implemented call directly")/*makeCall({ phoneNumber: data.contactNumber, leadId: data.leadId })*/} fullWidth>Call</Button> </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Email:</Typography></Grid>
                                    <Grid size={10}>
                                        <Grid container justifyContent="space-between" alignItems="center">
                                            <Grid size={!data.sentEmail ? 10 : 8}><Typography variant="body1">{data.email}</Typography></Grid>
                                            {!data.sentEmail
                                                ? <Grid size={2}><Button variant="contained" size='small' onClick={() => sendEmail(data.leadId)} fullWidth>Send Email</Button> </Grid>
                                                : <Grid size={4}><Typography textAlign="right" variant="body1">{data.dateTimeEmailSent ? ("Email sent - " + new Date(data.dateTimeEmailSent).toLocaleString("en-GB")) : ""}</Typography></Grid>}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Request details:</Typography></Grid>
                                    <Grid size={9}><Typography variant="body1">{data.description}</Typography></Grid>
                                </Grid>
                            </Paper>
                        </Paper>
                    </>)}
                    {value === 1 && index === 1 && (
                        <>
                            {data.notes.map((note: { dateTimeCreated: string | number | Date; userName: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; action: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; notes: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }, index: any) => (
                                <Paper elevation={4} sx={{ p: .5, mt: 1 }}>
                                    <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                        <Grid container justifyContent="flex-start" alignItems="center">
                                            <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Timestamp:</Typography></Grid>
                                            <Grid size={10}><Typography variant="body1">{new Date(note.dateTimeCreated).toLocaleString("en-GB")}</Typography></Grid></Grid>
                                    </Paper>
                                    <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                        <Grid container justifyContent="flex-start" alignItems="center">
                                            <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">User name:</Typography></Grid>
                                            <Grid size={10}><Typography variant="body1">{note.userName}</Typography></Grid></Grid>
                                    </Paper>
                                    <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                        <Grid container justifyContent="flex-start" alignItems="center">
                                            <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Action:</Typography></Grid>
                                            <Grid size={10}><Typography variant="body1">{note.action}</Typography></Grid></Grid>
                                    </Paper>
                                    <Paper elevation={3} sx={{ paddingInline: .5, paddingBlock: 1, m: .5 }}>
                                        <Grid container justifyContent="flex-start" alignItems="center">
                                            <Grid sx={{ pr: 2 }} size={2}><Typography textAlign="right" variant="body1">Notes:</Typography></Grid>
                                            <Grid size={10}><Typography variant="body1">{note.notes}</Typography></Grid></Grid>
                                    </Paper>
                                </Paper>
                            ))}
                        </>
                    )}
                </TabPanel>
            ))
            }
        </Box >)
    );
}

EnquiryTabs.displayName = name;

export default React.memo(EnquiryTabs);